'use client';

import { ContentPublicRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import styled from '@emotion/styled';
import { HomeLayout } from 'app-components/common/layout/HomeLayout';
import Head from 'next/head';
import React from 'react';
import { PageTitle } from 'ui-components/common/PageTitle';
import { ContentBodyContainer } from 'ui-components/layout/containers/ContentBodyCenterContainer';

interface SiteMapContentsPageProps {
  offset: number;
  limit: number;
  contentIds: number[];
  contents: Record<string, ContentPublicRelayDto>;
}

interface SiteMapContentListProps {
  contentIds: number[];
  contents: Record<string, ContentPublicRelayDto>;
}

const SiteMapContentList = ({ contentIds, contents }: SiteMapContentListProps) => (
  <>
    {contentIds.map(
      id =>
        contents[id] && (
          <li key={id}>
            <a href={`/contents/${contents[id].id}`}>{contents[id].title}</a>
          </li>
        ),
    )}
  </>
);

export const SiteMapContentsPage = ({ offset, limit, contentIds, contents }: SiteMapContentsPageProps) => (
  <>
    <Head>{contentIds.length && <link rel="next" href={`/sitemap/contents?offset=${offset + limit}`} />}</Head>
    <HomeLayout>
      <ContentBodyContainer>
        <ContentAreaWrapper>
          <PageTitle title="전체 작품 목록" />
          <SiteMapContentList contentIds={contentIds} contents={contents} />
        </ContentAreaWrapper>
      </ContentBodyContainer>
    </HomeLayout>
  </>
);

const ContentAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 50vh;
`;
